import { Injectable } from "@angular/core";
import { IApiError } from "app/bundles/requests/shared/models/apiError";
import { IApiErrorSuccessDTO } from "app/bundles/requests/shared/models/apiErrorSuccess";
import { Subject } from "rxjs";

@Injectable()
export class ErrorMessageService {
  private notify = new Subject<any>();
  notifyObservable = this.notify.asObservable();

  public notifyCustomError(error: Error) {
    this.notify.next({ option: "customError", value: error });
  }

  public notifyError(error: { error: { error: IApiError }; status: number }) {
    this.notify.next({ option: "errorMessage", value: error });
  }

  public notifyInfo(data: IApiErrorSuccessDTO, status: number) {
    this.notify.next({ option: "infoMessage", value: { error: data, status } });
  }
}
